<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش گزارش ورود</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="10">
            <v-select color="black" label="نمایش بر اساس نوع کاربر" v-model="userType" @change="getEntities"
                      :items="[{text:'مربی',value:'instructor'},{text:'هنرجو',value:'student'},{text:'ادمین',value:'admin'},{text:'تمام کاربر ها',value:'all'}]"></v-select>
          </v-col>
          <v-col cols="2">
            <v-btn style="letter-spacing: normal" color="primary" @click="getEntities">بروزرسانی</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="logs.data"
                hover
                :options.sync="options"
                :items-per-page="logs.per_page"
                :server-items-length="logs.total"
                item-value="index"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                :loading="loading"
            >
              <template v-slot:[`item.is_logged_in`]="{item}">
                <v-icon color="success" v-if="item.is_logged_in">mdi-check</v-icon>
                <v-icon color="error" v-else>mdi-close</v-icon>
              </template>
              <template v-slot:[`item.login_method`]="{item}">
                <v-chip x-small color="primary" text-color="white" v-if="item.login_method === 'otp'">OTP</v-chip>
                <v-chip x-small color="secondary" text-color="white" v-else-if="item.login_method === 'password'">Password</v-chip>
                <span v-else>-</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "OtpIndexView",
  watch: {
    options: {
      handler() {
        this.getEntities()
      },
      deep: true,
    },
  },
  data() {
    return {
      userType: "all",
      options: {},
      loading: true,
      credit: null,
      logs: {
        current_page: 1
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'شناسه کاربر', value: 'user_id', align: 'center'},
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'نوع کاربری', value: 'type', align: 'center'},
        {text: 'روش ورود', value: 'login_method', align: 'center'},
        {text: 'زمان درخواست کد', value: 'created_at_fa', original_value: 'created_at', align: 'center'},
        {text: 'کد', value: 'code', align: 'center'},
        {text: 'وارد شده؟', value: 'is_logged_in', align: 'center'},
        {text: 'زمان ورود', value: 'updated_at_fa',original_value: 'updated_at', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getEntities()
  },
  methods: {
    getEntities() {
      let url = window.urlBuilder(this.logs, 'message/otp/index', {type: this.userType, ...this.options}, this.headers);
      window.axios.get(url).then((res) => {
        this.logs = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
  }
}
</script>

<style scoped>

</style>
